export const objToArray = <U = any, T = any>(obj?: Record<string, T>, func?: (data: T, id: string) => U): U[] => {
  return Object.entries(obj || {})
    .filter(([, data]: [string, T]) => !!data)
    .map(([id, data]: [string, T]) => {
      return {
        ...func?.(data, id),
      } as U;
    });
};
